module.exports = __webpack_public_path__ + "img/bottle_test_thumb.19e0f785.jpg";